import type { ComponentRef, OnDestroy, OnInit } from '@angular/core';
import { Component, Inject, ViewChild, ViewContainerRef } from '@angular/core';
import type { DialogConfig, DialogData, IDialogContentComponent } from './modal-dialog.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})

export class ModalDialogComponent<TResult, TInputEntity> implements OnInit, OnDestroy  {
  @ViewChild('target', { read: ViewContainerRef, static: true }) vcRef?: ViewContainerRef;

  config: DialogConfig;
  dialogContentRef?: ComponentRef<IDialogContentComponent<TResult, TInputEntity>>;

  constructor(
    public dialogRef: MatDialogRef<ModalDialogComponent<TResult, TInputEntity>>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<TResult, TInputEntity>
  ) {
    this.config = this.data.params.config;
  }

  ngOnInit(): void {
    if (this.vcRef) {
      this.vcRef.clear();
      this.dialogContentRef = this.vcRef.createComponent(this.data.dialogContentComponent);
      this.dialogContentRef.instance.input = this.data.params.input;
    }

  }

  ngOnDestroy(): void {
    if (this.dialogContentRef) {
      this.dialogContentRef.destroy();
    }
  }

  save(): void {
    if (this.dialogContentRef) {
      const result = this.dialogContentRef.instance.getResult();
      this.dialogRef.close(result);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  isDisabled(): boolean {
    if (this.dialogContentRef) {
      return this.dialogContentRef.instance.isDisabled();
    }

    return true;
  }
}
